import { createSlice } from "@reduxjs/toolkit";

export const customerProductSummary = createSlice({
  name: "customerProductSummary",
  initialState: {
    getCustomerProduct: [],
    isLoading: false,
  },
  reducers: {
    onGetCustomerProduct: () => {
      return {
        getCustomerProduct: [],
        isLoading: true,
      };
    },
    onGetCustomerProductSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        getCustomerProduct: data,
        message,
        status_code,
        isLoading: false,
      };
    },
    onGetCustomerProductError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        getCustomerProduct: data,
        message,
        status_code,
        isLoading: false,
      };
    },
    OnGetCustomerProductReset: (state) => {
      return {
        ...state,
        getCustomerProduct: [],
        message: "",
        status_code: null,
      };
    },
  },
});

export const {
  onGetCustomerProduct,
  onGetCustomerProductSuccess,
  onGetCustomerProductError,
  OnGetCustomerProductReset,
} = customerProductSummary.actions;

export default customerProductSummary.reducer;
